import { render, staticRenderFns } from "./FancySelect.vue?vue&type=template&id=12b670e0"
import script from "./FancySelect.vue?vue&type=script&lang=ts"
export * from "./FancySelect.vue?vue&type=script&lang=ts"
import style0 from "./FancySelect.vue?vue&type=style&index=0&id=12b670e0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b670e0')) {
      api.createRecord('12b670e0', component.options)
    } else {
      api.reload('12b670e0', component.options)
    }
    module.hot.accept("./FancySelect.vue?vue&type=template&id=12b670e0", function () {
      api.rerender('12b670e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/fancy-select/FancySelect.vue"
export default component.exports